var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOnlineDevices = function SvgOnlineDevices(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40C44.4183 0 48 3.58172 48 8V40C48 44.4183 44.4183 48 40 48H8C3.58172 48 0 44.4183 0 40V0Z",
    fill: "#1E967E",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 27C29.6569 27 31 25.6569 31 24C31 22.3431 29.6569 21 28 21C26.3431 21 25 22.3431 25 24C25 25.6569 26.3431 27 28 27Z",
    fill: "#1E967E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17H28C29.8565 17 31.637 17.7375 32.9497 19.0503C34.2625 20.363 35 22.1435 35 24C35 25.8565 34.2625 27.637 32.9497 28.9497C31.637 30.2625 29.8565 31 28 31H20C18.1435 31 16.363 30.2625 15.0503 28.9497C13.7375 27.637 13 25.8565 13 24V24C13 22.1435 13.7375 20.363 15.0503 19.0503C16.363 17.7375 18.1435 17 20 17V17Z",
    stroke: "#1E967E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOnlineDevices);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "online-devices.e43cad7b0ee0e33061e4e5d384300c94.svg";